import { render, staticRenderFns } from "./DocumentRoutingFileViewer.vue?vue&type=template&id=4752237b&"
import script from "./DocumentRoutingFileViewer.vue?vue&type=script&lang=js&"
export * from "./DocumentRoutingFileViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports